import { render, staticRenderFns } from "./StepVehicles.vue?vue&type=template&id=2f275c26"
import script from "./StepVehicles.vue?vue&type=script&lang=js"
export * from "./StepVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports